import React, { createContext, useContext } from 'react'
import styled from 'styled-components'
import ContactPage from '../../components/contact/contact-page'
import breakpoints from '../../styles/breakpoints'
import { ButtonLink } from '../../components/system/forms/button'
import { FaDownload } from 'react-icons/fa'
import { withApollo } from '../../apollo/apollo'
import RentalForm from '../../components/contact/rental-form'
import { nowTz } from '../../utils/moment-tz'

const EARLIEST_EVENT_DAYS_OFFSET = 90
export const EarliestEventContext = createContext({
  earliestEventDaysOffset: EARLIEST_EVENT_DAYS_OFFSET,
  earliestEventDate: ''
})

const Description = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: 1fr 2fr;
  }
`

const Downloads = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${ButtonLink} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (min-width: ${breakpoints.lg}) {
    ${ButtonLink} {
      width: 250px;
    }
  }

  ${ButtonLink}:last-of-type {
    margin-top: ${props => props.theme.spacing.base400};
  }
`

const Rental = ({ earliestEventDate }: { earliestEventDate: string }) => {
  return (
    <EarliestEventContext.Provider
      value={{ earliestEventDaysOffset: EARLIEST_EVENT_DAYS_OFFSET, earliestEventDate }}
    >
      <ContactPage title="Rental Inquiry">
        <h2>Rental Inquiry</h2>
        <Description>
          <p>
            If you are interested in renting any of the Performing Arts Center venues, please review
            the venue handbook, rental rate sheet and submit the form below.
          </p>
          <Downloads>
            <ButtonLink href="/PAC-Rental-Rates.pdf" target="_blank" variant="outlined">
              <span>
                <strong>Rental</strong> Rates
              </span>
              <FaDownload />
            </ButtonLink>
            <ButtonLink href="/PAC-Handbook.pdf" target="_blank" variant="outlined">
              <span>
                <strong>Venue</strong> Handbook
              </span>
              <FaDownload />
            </ButtonLink>
          </Downloads>
        </Description>
        <RentalForm />
      </ContactPage>
    </EarliestEventContext.Provider>
  )
}

const getEarliestEventDate = () => {
  return nowTz()
    .add(EARLIEST_EVENT_DAYS_OFFSET, 'days')
    .format('MMMM Do, YYYY')
}

Rental.getInitialProps = async () => {
  return {
    earliestEventDate: getEarliestEventDate()
  }
}

export default withApollo(Rental)
